import { ActionTypes, CALL_API, MiddlewareAction } from './api.js';

export function axiosGet(
  path: string,
  types: ActionTypes,
  { ...restParams }: { [key: string]: any } = {},
): MiddlewareAction {
  return {
    [CALL_API]: {
      endpoint: path,
      config: { method: 'GET' },
      types,
      ...restParams,
    },
  };
}

export function axiosPost(
  path: string,
  types: ActionTypes,
  requestParams: any,
  { ...restParams }: { [key: string]: any } = {},
): MiddlewareAction {
  return {
    [CALL_API]: {
      endpoint: path,
      config: {
        data: requestParams,
        method: 'POST',
      },
      types,
      ...restParams,
    },
  };
}

export function axiosPut(
  path: string,
  types: ActionTypes,
  requestParams: any,
  { ...restParams }: { [key: string]: any } = {},
): MiddlewareAction {
  return {
    [CALL_API]: {
      endpoint: path,
      config: {
        data: requestParams,
        method: 'PUT',
      },
      types,
      ...restParams,
    },
  };
}

export function axiosPatch(
  path: string,
  types: ActionTypes,
  requestParams: any,
  { ...restParams }: { [key: string]: any } = {},
): MiddlewareAction {
  return {
    [CALL_API]: {
      endpoint: path,
      config: {
        data: requestParams,
        method: 'PATCH',
      },
      types,
      ...restParams,
    },
  };
}

export function axiosDelete(
  path: string,
  types: ActionTypes,
  params: { [key: string]: any } = {},
): MiddlewareAction {
  return {
    [CALL_API]: {
      endpoint: path,
      config: {
        method: 'DELETE',
      },
      types,
      ...params,
    },
  };
}
